import React from 'react';
import { Container, Paper, Typography } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';

const PattaIssueReport = () => {
  const { lang } = useLanguage();

  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4, mt: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          {lang === 'telugu' ? 'పట్టా జారీ నివేదిక' : 'पट्टा जारी निवेदिका'}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          {lang === 'telugu' 
            ? 'ఈ ఫీచర్ త్వరలో అందుబాటులోకి వస్తుంది' 
            : 'यह सुविधा शीघ्र उपलब्ध होगी'}
        </Typography>
      </Paper>
    </Container>
  );
};

export default PattaIssueReport;
